export enum YfmTableNode {
    Table = 'yfm_table',
    Body = 'yfm_tbody',
    Row = 'yfm_tr',
    Cell = 'yfm_td',
}

export enum YfmTableAttr {
    Colspan = 'colspan',
    Rowspan = 'rowspan',
    CellAlign = 'data-cell-align',
}
